export default __webpack_public_path__ + "static/media/about-thumb-5.4a5ef2ec.png";